export default {
    SOLICITADO: 1,
    AGUARDANDO_RESULTADO: 2,
    REALIZADO: 3,
    NAO_REALIZADO: 4
}